import React from 'react';
import LocationPicker from '@adsk/bim360-matrix-react-location-picker';
import {locationsTreeNodesType} from '../../constants/proptype-validation';
import i18n from '../../utils/i18n';
import PropTypes from 'prop-types';

const IssueLocationPicker = ({
  selectedEventKey,
  valid,
  disabled,
  onChange,
  locationsTreeNodes,
  isLoading,
  loadingError,
  getDefaultLocationTree,
  container
}) => (
  <LocationPicker
    selectedEventKey={selectedEventKey}
    placeholder={i18n.t('new.placeholder.location')}
    valid={valid}
    searchIcon
    searchPlaceholder={i18n.t('filter.locationSearchPlaceholder')}
    disabled={disabled}
    onChange={onChange}
    locationApiPayload={locationsTreeNodes}
    isLoading={isLoading}
    loadingError={loadingError}
    onTryAgain={getDefaultLocationTree}
    popoverContainer={container}
  />
);

IssueLocationPicker.displayName = 'IssueLocationPicker';

IssueLocationPicker.defaultProps = {
  valid: true
};

IssueLocationPicker.propTypes = {
  selectedEventKey: PropTypes.string,
  valid: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  locationsTreeNodes: locationsTreeNodesType,
  isLoading: PropTypes.bool,
  loadingError: PropTypes.bool,
  getDefaultLocationTree: PropTypes.func.isRequired,
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

export default IssueLocationPicker;
